import { render, staticRenderFns } from "./VerticalStatistic.vue?vue&type=template&id=174eaeef"
import script from "./VerticalStatistic.vue?vue&type=script&lang=ts"
export * from "./VerticalStatistic.vue?vue&type=script&lang=ts"
import style0 from "./VerticalStatistic.vue?vue&type=style&index=0&id=174eaeef&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports